"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseS2LevelForTopLength = exports.turfUnitToKm = exports.s2CellEquatorSizesKm = void 0;
exports.getMapDimsFromBounds = getMapDimsFromBounds;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const turf_1 = require("@turf/turf");
const TypeHelpers_1 = require("../../TypeHelpers");
const TurfUtils_1 = require("../TurfUtils");
exports.s2CellEquatorSizesKm = {
    1: 10000, // ~10,000 km
    2: 5000, // ~5,000 km
    3: 2500, // ~2,500 km
    4: 1260, // ~1,260 km
    5: 630, // ~630 km
    6: 320, // ~320 km
    7: 160, // ~160 km
    8: 80, // ~80 km
    9: 40, // ~40 km
    10: 20, // ~20 km
    11: 10, // ~10 km
    12: 5, // ~5 km
    13: 2.5, // ~2.5 km
    14: 1.2, // ~1.2 km
    15: 0.6, // ~0.6 km
    16: 0.3, // ~0.3 km
    17: 0.15, // ~150 m
    18: 0.08, // ~80 m
    19: 0.04, // ~40 m
    20: 0.02 // ~20 m
};
exports.turfUnitToKm = {
    meters: 0.001,
    metres: 0.001,
    millimeters: 0.000001,
    millimetres: 0.000001,
    centimeters: 0.00001,
    centimetres: 0.00001,
    kilometers: 1,
    kilometres: 1,
    miles: 1.609,
    nauticalmiles: 1.852,
};
const getBaseS2LevelForTopLength = (topLenthVal, unit) => {
    const km = topLenthVal * exports.turfUnitToKm[unit];
    const matcheEntry = Object.entries(exports.s2CellEquatorSizesKm).find(([level, v], i) => {
        const next = exports.s2CellEquatorSizesKm[i + 1];
        return !(0, iotv_v3_types_1.isNonNaNNumber)(next) || next < km;
    });
    const matchedLevel = parseInt(matcheEntry?.[0] ?? '1');
    return matchedLevel;
};
exports.getBaseS2LevelForTopLength = getBaseS2LevelForTopLength;
function getMapDimsFromBounds({ bounds, units, precision = 0 }) {
    if (bounds) {
        const { lat: neLat, lng: neLng } = bounds.ne;
        const { lat: swLat, lng: swLng } = bounds.sw;
        const xDist = (0, TypeHelpers_1.roundDecimals)((0, turf_1.distance)((0, TurfUtils_1.gPointToTPosition)({ lat: neLat, lng: swLng }), (0, TurfUtils_1.gPointToTPosition)({ lat: neLat, lng: neLng }), { units }), precision);
        const yDist = (0, TypeHelpers_1.roundDecimals)((0, turf_1.distance)((0, TurfUtils_1.gPointToTPosition)({ lat: neLat, lng: swLng }), (0, TurfUtils_1.gPointToTPosition)({ lat: swLat, lng: swLng }), { units }), precision);
        return { xDist, yDist, units };
    }
    else {
        return null;
    }
}
